import { render, staticRenderFns } from "./employment2.vue?vue&type=template&id=236a8e89&"
import script from "./employment2.vue?vue&type=script&lang=js&"
export * from "./employment2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports